/* [SWT] The Vault v2 — states, spring reveal, countdown. Toronto wall clock, DST-safe via Intl. */
(function () {
  if (window.customElements && customElements.get('swt-vault')) return;
  var TZ = 'America/Toronto';

  class SwtVault extends HTMLElement {
    connectedCallback() {
      var ds = this.dataset;
      this.S = {};
      for (var k in ds) { if (k.length > 1 && k[0] === 's' && k[1] === k[1].toUpperCase() && k[1] !== k[1].toLowerCase()) { this.S[k.slice(1).replace(/[A-Z]/g, function (c) { return '_' + c.toLowerCase(); }).replace(/^_/, '')] = ds[k]; } }
      this.total = parseInt(ds.total, 10) || 0;
      this.earlyMs = (parseFloat(ds.earlyHours) || 0) * 3600 * 1000;
      var serverNow = parseInt(ds.serverNow, 10);
      this.skew = isFinite(serverNow) && serverNow > 0 ? serverNow * 1000 - Date.now() : 0;
      this.fakeOffset = 0;
      try { var q = new URLSearchParams(location.search).get('swt_now'); if (q) { var f = this.wallToEpoch(q); if (f !== null) this.fakeOffset = f - this.now(); } } catch (e) {}

      this.days = Array.prototype.slice.call(this.querySelectorAll('[data-swtv-day]'));
      this.days.forEach(function (el) { el._reveal = this.wallToEpoch(el.dataset.reveal); el._state = null; }.bind(this));

      this.el = {
        status: this.querySelector('[data-swtv-status]'), statusText: this.querySelector('[data-swtv-status-text]'),
        day: this.querySelector('[data-swtv-hero-day]'), title: this.querySelector('[data-swtv-hero-title]'), fact: this.querySelector('[data-swtv-hero-fact]'),
        price: this.querySelector('[data-swtv-price]'), now: this.querySelector('[data-swtv-price-now]'), was: this.querySelector('[data-swtv-price-was]'),
        actions: this.querySelector('[data-swtv-hero-actions]'), door: this.querySelector('[data-swtv-door]'), glyph: this.querySelector('[data-swtv-door-glyph]'), frost: this.querySelector('[data-swtv-door-frost]'),
        num: this.querySelector('[data-swtv-door-num]'), date: this.querySelector('[data-swtv-door-date]'),
        cd: this.querySelector('[data-swtv-countdown]'), cdLabel: this.querySelector('[data-swtv-cd-label]'), cdValue: this.querySelector('[data-swtv-cd-value]'),
        opened: this.querySelector('[data-swtv-opened]'), next: this.querySelector('[data-swtv-next]'), dial: this.querySelector('[data-swtv-dial]')
      };
      this.preview = null;
      if (ds.designMode === 'true') this.initEditor();
      this.lockSvg = this.el.glyph ? this.el.glyph.innerHTML : '';
      this.signupAnchor = ds.signupAnchor || '#swtv-signup';

      this.buildDial();
      this.initPass();
      this.initSpring();
      this.initBar();
      this.initSignupForm();

      this.heroKey = null;
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
      if (this._onSel) { document.removeEventListener('shopify:block:select', this._onSel); document.removeEventListener('shopify:block:deselect', this._onDesel); }
    }

    /* ---- Theme editor: selecting a day block previews that day as open ---- */
    initEditor() {
      var self = this, key = 'swtv_preview';
      try { var d = sessionStorage.getItem(key); if (d) this.preview = this.querySelector('[data-swtv-day][data-date="' + d + '"]'); } catch (e) {}
      this._onSel = function (e) {
        var li = e.target && e.target.closest ? e.target.closest('[data-swtv-day]') : null;
        if (!li || !self.contains(li)) return;
        self.preview = li; try { sessionStorage.setItem(key, li.dataset.date); } catch (x) {}
        self.heroKey = null; self.tick();
      };
      this._onDesel = function (e) {
        if (!e.target || !self.contains(e.target)) return;
        self.preview = null; try { sessionStorage.removeItem(key); } catch (x) {}
        self.heroKey = null; self.tick();
      };
      document.addEventListener('shopify:block:select', this._onSel);
      document.addEventListener('shopify:block:deselect', this._onDesel);
    }

    now() { return Date.now() + this.skew + this.fakeOffset; }
    reducedMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    tpl(str, map) { return String(str || '').replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
    pad(n) { return n < 10 ? '0' + n : String(n); }
    showHint(el, animate) {
      var E = this.el, h = el && el.dataset.hint;
      if (h) { E.glyph.innerHTML = '<img class="is-hint" src="' + this.esc(h) + '" alt="" aria-hidden="true">'; E.door.dataset.hinted = '1'; if (animate) this.spTo(0.45); else this.spSet(0.45); }
      else { E.glyph.innerHTML = this.lockSvg; E.door.dataset.hinted = '0'; if (animate) this.spTo(0); else this.spSet(0); }
    }

    /* "YYYY-MM-DDTHH:MM" Toronto wall clock -> epoch ms */
    wallToEpoch(wall) {
      var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(wall || '');
      if (!m || typeof Intl === 'undefined') return null;
      var fmt;
      try { fmt = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch (e) { return null; }
      var offsetAt = function (ms) { var p = {}; fmt.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; }); var h = parseInt(p.hour, 10); if (h === 24) h = 0; return Date.UTC(+p.year, +p.month - 1, +p.day, h, +p.minute, +p.second) - ms; };
      var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0);
      var o1 = offsetAt(guess), e = guess - o1, o2 = offsetAt(e);
      return o2 !== o1 ? guess - o2 : e;
    }
    fmtTime(ms) { try { return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, hour: 'numeric', minute: '2-digit' }).format(new Date(ms)).replace(/\./g, '').toLowerCase().replace(/\s?([ap])m/, ' $1m'); } catch (e) { return ''; } }
    fmtShort(ms) { try { return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(ms)); } catch (e) { return ''; } }

    /* ---- Vault Pass: ?pass=TOKEN -> localStorage ---- */
    initPass() {
      this.hasPass = false;
      this.passKey = 'swt_vault_pass';
      var param = this.dataset.passParam || 'pass', token = this.dataset.passToken || '', key = this.passKey;
      try {
        var v = new URLSearchParams(location.search).get(param);
        if (v && (!token || v === token)) localStorage.setItem(key, v);
        var stored = localStorage.getItem(key);
        if (stored && (!token || stored === token)) this.hasPass = true;
      } catch (e) {}
      var holder = this.querySelector('[data-swtv-pass-holder]');
      if (this.hasPass && holder) holder.hidden = false;
    }
    grantPass() {
      var token = this.dataset.passToken || '1';
      try { localStorage.setItem(this.passKey, token); } catch (e) {}
      this.hasPass = true;
      var holder = this.querySelector('[data-swtv-pass-holder]');
      if (holder) holder.hidden = false;
      this.heroKey = null; this.tick();
    }

    /* ---- State per day ---- */
    todayItem(now) { var c = null; this.days.forEach(function (d) { if (d._reveal !== null && d._reveal - this.earlyMs <= now) c = d; }.bind(this)); return c; }
    nextItem(now) { var n = null; this.days.forEach(function (d) { if (d._reveal !== null && d._reveal > now && (!n || d._reveal < n._reveal)) n = d; }); return n; }
    stateFor(el, now, today) {
      if (this.preview && el === this.preview) return el.dataset.soldOut === 'true' ? 'soldout' : 'live';
      var f = el.dataset.forced;
      if (f && f !== 'auto') return f === 'sold_out' ? 'soldout' : f; // locked | live
      if (el._reveal === null) return 'locked';
      var isToday = el === today, sold = el.dataset.soldOut === 'true';
      if (now >= el._reveal) return isToday ? (sold ? 'soldout' : 'live') : 'past';
      if (this.hasPass && this.earlyMs > 0 && now >= el._reveal - this.earlyMs) return sold ? 'soldout' : 'early';
      return 'locked';
    }

    /* ---- Critically damped spring (damping 1.0, response 0.4). Interruptible: retargets from the live value. ---- */
    initSpring() {
      var self = this, w = 2 * Math.PI / 0.4;
      this.sp = { v: 0, vel: 0, target: 0, raf: 0 };
      this.spFrame = function (p) {
        var blur = 24 * (1 - p), scale = 0.96 + 0.04 * p;
        if (self.el.glyph) { self.el.glyph.style.filter = blur > 0.3 ? 'blur(' + blur.toFixed(2) + 'px)' : 'none'; self.el.glyph.style.transform = 'scale(' + scale.toFixed(4) + ')'; }
        if (self.el.frost) self.el.frost.style.opacity = (1 - p).toFixed(3);
      };
      this.spSet = function (x) { self.sp.v = x; self.sp.vel = 0; self.sp.target = x; cancelAnimationFrame(self.sp.raf); self.spFrame(x); };
      this.spTo = function (target) {
        self.sp.target = target;
        if (self.reducedMotion()) { self.spSet(target); return; }
        var last = performance.now();
        cancelAnimationFrame(self.sp.raf);
        var step = function (t) {
          var dt = Math.min(0.05, (t - last) / 1000); last = t;
          var s = self.sp, a = -w * w * (s.v - s.target) - 2 * w * s.vel;
          s.vel += a * dt; s.v += s.vel * dt;
          if (Math.abs(s.v - s.target) < 0.0005 && Math.abs(s.vel) < 0.0005) { s.v = s.target; s.vel = 0; self.spFrame(s.v); return; }
          self.spFrame(s.v); s.raf = requestAnimationFrame(step);
        };
        this.sp.raf = requestAnimationFrame(step);
      };
      this.spSet(0);
    }

    /* ---- Dial: one tick per reveal ---- */
    buildDial() {
      this.ticks = [];
      if (!this.el.dial || !this.total) return;
      for (var i = 0; i < this.total; i++) {
        var ang = (-90 + i * (360 / this.total)) * Math.PI / 180, r1 = 33, r2 = 40;
        var t = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        t.setAttribute('x1', 48 + r1 * Math.cos(ang)); t.setAttribute('y1', 48 + r1 * Math.sin(ang));
        t.setAttribute('x2', 48 + r2 * Math.cos(ang)); t.setAttribute('y2', 48 + r2 * Math.sin(ang));
        t.setAttribute('class', 'tick'); this.el.dial.appendChild(t); this.ticks.push(t);
      }
    }

    tick() {
      var now = this.now(), S = this.S, opened = 0, today = this.preview || this.todayItem(now), todayState = null;
      this.days.forEach(function (el, i) {
        var st = this.stateFor(el, now, today);
        if (st !== 'locked') opened++;
        if (st !== el._state) this.paintCard(el, st);
        el._state = st;
        if (this.ticks[i]) { this.ticks[i].classList.toggle('is-on', st !== 'locked'); this.ticks[i].classList.toggle('is-today', el === today && st !== 'locked'); }
        if (st === 'locked') { var w = el.querySelector('[data-swtv-card-when]'); if (w) { var line = this.tpl(S.opens, { date: this.fmtShort(el._reveal), time: this.fmtTime(el._reveal) }); if (w.textContent !== line) w.textContent = line; } }
      }.bind(this));
      if (this.el.opened && this.el.opened.textContent !== String(opened)) this.el.opened.textContent = String(opened);
      if (today) todayState = this.stateFor(today, now, today);
      this.paintHero(today, todayState || 'locked');

      var nxt = this.nextItem(now);
      if (nxt) {
        var s = Math.max(0, Math.ceil((nxt._reveal - now) / 1000)), dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
        if (this.el.cd) { this.el.cd.hidden = false; this.el.cdLabel.textContent = (today && todayState && todayState !== 'locked') ? S.next : S.opens_in; this.el.cdValue.textContent = (dd > 0 ? dd + 'd ' : '') + this.pad(hh) + ':' + this.pad(mm) + ':' + this.pad(ss); }
        if (this.el.next) this.el.next.textContent = this.fmtShort(nxt._reveal) + ', ' + this.fmtTime(nxt._reveal);
      } else {
        if (this.el.cd) this.el.cd.hidden = true;
        if (this.el.next) this.el.next.textContent = this.tpl(S.all_open, { n: this.total });
      }
    }

    paintCard(el, st) {
      var S = this.S;
      el.dataset.state = st;
      var locked = el.querySelector('[data-swtv-face="locked"]'), tplFace = el.querySelector('template[data-swtv-face="revealed"]'), live = el.querySelector('[data-swtv-face="revealed-live"]');
      var show = st !== 'locked';
      if (show && tplFace) {
        if (!live) { live = document.createElement('div'); live.setAttribute('data-swtv-face', 'revealed-live'); live.appendChild(document.importNode(tplFace.content, true)); el.appendChild(live); }
        live.hidden = false; if (locked) locked.hidden = true;
        var s1 = live.querySelector('[data-swtv-card-state]');
        if (s1) s1.textContent = st === 'early' ? S.early : st === 'soldout' ? S.soldout : st === 'past' ? S.past : S.live;
      } else {
        if (locked) {
          locked.hidden = false;
          var s2 = locked.querySelector('[data-swtv-card-state]'), t2 = locked.querySelector('.swtv__card-title'), w2 = locked.querySelector('[data-swtv-card-when]');
          if (show && el.dataset.tbc !== 'true') { if (s2) s2.textContent = S.live; if (w2) w2.textContent = S.refresh_text; } // open, but this page load predates the reveal
          else if (show) { if (s2) s2.textContent = st === 'past' ? S.past : S.live; if (w2) w2.textContent = ''; if (t2) t2.textContent = 'Day ' + el.dataset.dayNo; }
          else if (s2) s2.textContent = S.locked;
        }
        if (live) live.hidden = true;
      }
    }

    paintHero(el, st) {
      var S = this.S, E = this.el, key = (el ? el.dataset.date : 'none') + ':' + st;
      if (key === this.heroKey) return;
      var wasOpen = this.heroKey && this.heroKey.split(':')[1] !== 'locked' && this.heroKey.split(':')[0] === (el ? el.dataset.date : '');
      this.heroKey = key;
      E.status.dataset.state = st; E.door.dataset.state = st; E.actions.innerHTML = '';
      if (!el) { // before the first reveal
        E.statusText.textContent = S.locked; E.day.textContent = '';
        E.title.textContent = S.pre_title; E.fact.textContent = S.pre_text; E.price.hidden = true;
        var first = this.days[0]; if (first) { E.num.textContent = this.pad(first.dataset.dayNo); E.date.textContent = first.dataset.longDate; }
        this.showHint(first, false);
        E.actions.innerHTML = '<a class="swtv-btn swtv-btn--ghost" href="' + this.signupAnchor + '">' + this.esc(S.pass_cta) + '</a>';
        return;
      }
      E.num.textContent = this.pad(el.dataset.dayNo); E.date.textContent = el.dataset.longDate;
      E.day.textContent = this.tpl(S.day_of, { n: el.dataset.dayNo, total: this.total });
      if (st === 'locked') {
        E.statusText.textContent = S.locked;
        E.title.textContent = this.tpl(S.locked_title, { time: this.fmtTime(el._reveal) }); E.fact.textContent = S.locked_text; E.price.hidden = true;
        this.showHint(el, true);
        E.actions.innerHTML = '<a class="swtv-btn swtv-btn--ghost" href="' + this.signupAnchor + '">' + this.esc(S.pass_cta) + '</a>';
        return;
      }
      var payload = el.querySelector('template[data-swtv-hero-payload]');
      E.statusText.textContent = st === 'live' ? S.live : st === 'early' ? S.early : st === 'soldout' ? S.soldout : S.past;
      if (!payload && this.preview) {
        E.title.textContent = 'No product picked for this day'; E.fact.textContent = 'Pick a product in this block to preview it.'; E.price.hidden = true;
        E.glyph.innerHTML = this.lockSvg; this.spSet(0); return;
      }
      if (!payload) { // open, but the product isn't in this page load (cache) -> ask for a refresh
        E.title.textContent = S.refresh_title; E.fact.textContent = S.refresh_text; E.price.hidden = true;
        E.glyph.innerHTML = this.lockSvg; this.spSet(0);
        var b = document.createElement('button'); b.type = 'button'; b.className = 'swtv-btn swtv-btn--primary'; b.textContent = 'Refresh'; b.addEventListener('click', function () { location.reload(); });
        E.actions.appendChild(b); return;
      }
      var c = payload.content, get = function (sel) { var n = c.querySelector(sel); return n ? n.textContent.trim() : ''; };
      var url = get('[data-url]'), img = get('[data-img]');
      E.title.innerHTML = '<a href="' + this.esc(url) + '">' + this.esc(get('[data-title]')) + '</a>';
      E.fact.textContent = get('[data-fact]');
      E.price.hidden = false; E.now.textContent = get('[data-price-now]'); E.was.textContent = get('[data-price-was]');
      var fromHint = E.door.dataset.hinted === '1' ? this.sp.v : 0;
      E.glyph.innerHTML = img ? '<img src="' + this.esc(img) + '" alt="' + this.esc(get('[data-img-alt]')) + '" loading="eager">' : this.lockSvg;
      E.door.dataset.hinted = '0';
      E.actions.innerHTML = (st === 'soldout'
        ? '<a class="swtv-btn swtv-btn--ghost" href="' + this.esc(url) + '">' + this.esc(S.cta_soldout) + '</a>'
        : '<a class="swtv-btn swtv-btn--primary" href="' + this.esc(url) + '">' + this.esc(S.cta) + '</a>')
        + '<a class="swtv-btn swtv-btn--ghost" href="' + this.signupAnchor + '">' + this.esc(S.pass_cta) + '</a>';
      // The one orchestrated moment: plays once per visitor per day.
      var seenKey = 'swt_vault_seen_' + el.dataset.date, seen = false;
      try { seen = localStorage.getItem(seenKey) === '1'; } catch (e) {}
      if (seen && !wasOpen) { this.spSet(1); }
      else { this.spSet(fromHint); this.spTo(1); try { localStorage.setItem(seenKey, '1'); } catch (e) {} }
    }

    /* ---- Mobile bar: appears once the inline signup scrolls off; dismissible ---- */
    initBar() {
      var bar = this.querySelector('[data-swtv-bar]'), signup = this.querySelector('[data-swtv-signup]'), close = this.querySelector('[data-swtv-bar-close]');
      if (!bar || !signup) return;
      var dismissed = false; try { dismissed = sessionStorage.getItem('swt_vault_bar') === '1'; } catch (e) {}
      if (close) close.addEventListener('click', function () { dismissed = true; bar.classList.remove('is-shown'); try { sessionStorage.setItem('swt_vault_bar', '1'); } catch (e) {} });
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) { var e = entries[0]; bar.classList.toggle('is-shown', e.boundingClientRect.top < 0 && !e.isIntersecting && !dismissed); }, { threshold: 0 }).observe(signup);
    }

    /* ---- Signup form: native HTML, posts to Klaviyo's public subscribe API (no embed, no publish step).
            Subscribes the email to the main list (the list relationship carries consent), stamps vault_pass / vault_pass_year on the profile,
            then activates the Vault Pass on this device. ---- */
    initSignupForm() {
      var self = this, form = this.querySelector('[data-swtv-signup-form]'), msg = this.querySelector('[data-swtv-field-msg]');
      if (!form || !msg) return;
      var input = form.querySelector('input[type="email"]'), hp = form.querySelector('[data-swtv-hp]'), btn = form.querySelector('[data-swtv-submit]');
      var company = (form.dataset.company || '').trim(), list = (form.dataset.list || '').trim();
      var okText = form.dataset.okText || 'You’re in. Your Vault Pass is active on this device.';
      var errText = form.dataset.errText || 'That didn’t go through. Please try again in a moment.';
      var setMsg = function (cls, t) { msg.className = 'swtv__field-msg' + (cls ? ' ' + cls : ''); msg.textContent = t; };
      var busy = false;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        if (hp && hp.value) { setMsg('is-ok', okText); return; } // honeypot: bots get a fake success
        var v = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { input.setAttribute('aria-invalid', 'true'); setMsg('is-error', 'Enter an email address like you@example.com.'); input.focus(); return; }
        input.removeAttribute('aria-invalid');
        if (!company || !list) { setMsg('is-error', 'Signup form not connected yet (add the Klaviyo company and list IDs in the theme editor).'); return; }
        var token = self.dataset.passToken || '', year = self.days[0] ? parseInt(self.days[0].dataset.date.slice(0, 4), 10) : new Date().getFullYear();
        var props = {}; if (token) { props.vault_pass = token; props.vault_pass_year = year; }
        var payload = { data: { type: 'subscription', attributes: {
          custom_source: form.dataset.source || 'Vault page',
          profile: { data: { type: 'profile', attributes: { email: v, properties: props } } }
        }, relationships: { list: { data: { type: 'list', id: list } } } } };
        busy = true; if (btn) btn.disabled = true; setMsg('', 'Signing you up…');
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.status === 202 || r.ok) return null;
          return r.text().then(function (t) { throw new Error('Klaviyo ' + r.status + ' ' + t.slice(0, 200)); });
        }).then(function () {
          input.value = ''; form.hidden = true; setMsg('is-ok', okText); self.grantPass();
        }).catch(function (err) {
          try { console.warn('[swt-vault] signup failed:', err && err.message); } catch (x) {}
          setMsg('is-error', errText);
        }).then(function () { busy = false; if (btn) btn.disabled = false; });
      });
    }
  }
  if (window.customElements) customElements.define('swt-vault', SwtVault);
})();
